import React from 'react';
import { ReactComponent as LeftDialog } from '../../assets/leftDialog.svg';
import { ReactComponent as RightDialog } from '../../assets/rightDialog.svg';
import { ReactComponent as Payments } from '../../assets/payments.svg';

import s from './index.module.css';

const KeyFeatures = () => {
  return (
    <section className={s.keyFeaturesSection}>
      <h2 className={s.keyFeaturesHeader}>Выгодно и удобно</h2>
      <div className={s.blocks}>
        <div className={s.helpClients}>
          <div className={s.helpIcon}>
            <LeftDialog className={s.leftDialogIcon} />
            <RightDialog className={s.rightDialogIcon} />
          </div>
          <div className={s.helpText}>Помогайте клиентам<br/>с поиском деталей в чате</div>
        </div>
        <div className={s.getShares}>
          <div className={s.shares}>
            <div className={s.shareValue}>3</div>
          </div>
          <div className={s.shareText}>Получайте c оформленного заказа 3%</div>
        </div>
        <div className={s.consistentPayments}>
          <Payments className={s.paymentsIcon} />
          <div className={s.paymentText}>Получайте вознаграждение каждые две недели</div>
        </div>
      </div>
    </section>
  );
}

export default KeyFeatures;
